// extracted by mini-css-extract-plugin
export default {"mainClass":"job_mainClass__lOUW8","h1":"job_h1__r+ibW","tabClass":"job_tabClass__hw3q1"};